import React from 'react';
import { formatDateForInput } from '../../../lib/utils';

export default class DateRangePicker extends React.Component {

    onChange(event) {
        this.props.update(event.target.name, event.target.value);
    }

    render() {
        return (
            <div>
                <label className="input-label">Between Dates</label>
                <div className="date-inputs">
                    <input type="date" name="startDate" value={formatDateForInput(this.props.startDate)} max={this.props.endDate} onChange={this.onChange.bind(this)} />
                    <input type="date" name="endDate" value={formatDateForInput(this.props.endDate)} min={this.props.startDate} onChange={this.onChange.bind(this)}/>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/DateRangePicker.jsx